import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';

import { AppPage } from '../../AppPage';
import TopSection from '../TopSection';
import PreviewBodySection from '../PreviewBodySection';
import { FootSection } from '../FootSection';

/**
 * Preview Online Approval Lists component.
 *
 * @param props {Object}.
 * @param props.onSendLink {Function} Send a link.
 * @class
 */
const PreviewOnlineApprovalListsComponent = ({
  onGenerateEmailLink,
  onGenerateLink,
  onlineApproval,
  sending,
  emailLink,
}) => (
  <AppPage overline="Online Approval Preview" title={onlineApproval.get('approvalListLabel') || 'Approval List'}>
    <TopSection onlineApproval={onlineApproval} />
    <PreviewBodySection onlineApproval={onlineApproval} />
    <FootSection
      emailLink={emailLink}
      onGenerateEmailLink={onGenerateEmailLink}
      onGenerateLink={onGenerateLink}
      sending={sending}
    />
  </AppPage>
);

PreviewOnlineApprovalListsComponent.propTypes = {
  emailLink: PropTypes.string.isRequired,
  onGenerateEmailLink: PropTypes.func.isRequired,
  onGenerateLink: PropTypes.func.isRequired,
  onlineApproval: PropTypes.instanceOf(Map).isRequired,
  sending: PropTypes.bool.isRequired,
};

export const PreviewOnlineApprovalLists = memo(PreviewOnlineApprovalListsComponent);
